/** The token SizeType catalog shared with the movement geometry. */
export { CREATURE_SIZE_TYPES } from '../../../ft3d/engine/ft3d-creature-size.js';
